(function () {
	'use strict';

    angular.module("imApp").factory("transportAreasService", ['$ihttp', function ($ihttp) {
        let service = {
            listAreas: function (parms) {
                return $ihttp.post({
                    method: 1397,
                    parameters: parms || {}
                });
            }
		};

		return service;
	}]);
})();
